export const audio_settings = {
  music: localStorage.getItem('music_enabled') !== 'false',
  sound: localStorage.getItem('sound_enabled') !== 'false',
};

export const set_audio_setting = (name, value) => {
  audio_settings[name] = value;
  localStorage.setItem(`${name}_enabled`, value);
  window.dispatchEvent(new CustomEvent('audio_setting_change', {
    detail: { name, value },
  }));
};

export const play_sound = (audio, options = {}) => {
  if (!audio || !audio_settings.sound) {
    return;
  }

  const { loop = false, restart = true } = options;

  audio.loop = loop;

  if (restart) {
    audio.currentTime = 0;
  }

  const playPromise = audio.play();
  if (playPromise) {
    playPromise.catch(() => {});
  }
};

export const stop_sound = (audio) => {
  if (!audio) {
    return;
  }

  audio.pause();
  audio.currentTime = 0;
};
